import {getPointField} from "../../../helpers/sqftHelper";
import EventManager from "../store/sqftEventManager";
import {
  FREE_DRAW_TYPE,
  SIDEBAR_HIDDEN_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SIDEBAR_SHAPE_BUTTONS,
  SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS
} from "../../../constants";
import store from "../../../../../store";
import {getLockPointPos} from "./freeDrawHelper";

export default class RenderFreeDraw {

  static drawLines = (ctx, points) => {
    for (let i = 0; i < points.length; i++) {
      if (points[i + 1] !== undefined) {
        let posX = points[i].modelCorePoint.mixins.movable.posX;
        let posY = points[i].modelCorePoint.mixins.movable.posY;
        let pointField = getPointField(posX, posY);

        posX = points[i + 1].modelCorePoint.mixins.movable.posX;
        posY = points[i + 1].modelCorePoint.mixins.movable.posY;
        let nextPointField = getPointField(posX, posY);
        // let pointField = points[i].getPointCords();
        // let nextPointField = points[i + 1].getPointCords();
        if (i === 0) {
          ctx.moveTo(pointField.x, pointField.y);
        }
        ctx.lineTo(nextPointField.x, nextPointField.y);
      }
    }
  }

  static drawLastLine = (ctx, state) => {
    let posX = state.addedPoints[0].modelCorePoint.mixins.movable.posX;
    let posY = state.addedPoints[0].modelCorePoint.mixins.movable.posY;
    let pointField = getPointField(posX, posY);

    ctx.lineTo(pointField.x, pointField.y);
  }

  static drawLineFromPointV2ToMouse = (ctx, pointV2, shouldUseLockedMode = false) => {
    const reduxState = store.getState();
    const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
    const activeButton = reduxState.sqftMenuState.activeButton;

    if ((shouldUseLockedMode && isWallsLockMode && activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall)
      || (shouldUseLockedMode && activeButton === SIDEBAR_SHAPE_BUTTONS.freeDraw)
      || (shouldUseLockedMode && activeButton === SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS.freeDraw)
      || (shouldUseLockedMode && activeButton === SIDEBAR_SHAPE_BUTTONS.shapeFreeForm)
      || (shouldUseLockedMode && activeButton === SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw)
    ) {
      RenderFreeDraw.drawLineFromPointV2ToMouseLocked(ctx, pointV2);
    } else {
      RenderFreeDraw.drawLineFromPointV2ToMouseFree(ctx, pointV2);
    }
  }

  static drawLineFromPointV2ToMouseFree = (ctx, pointV2) => {
    ctx.beginPath();
    let posX = pointV2.modelCorePoint.mixins.movable.posX;
    let posY = pointV2.modelCorePoint.mixins.movable.posY;
    let pointField = getPointField(posX, posY);
    ctx.moveTo(pointField.x, pointField.y);

    const mousePos = EventManager.LastKnownMousePos;
    ctx.lineTo(mousePos.x, mousePos.y);
    ctx.stroke();
    ctx.closePath();
  }

  static drawLineFromPointV2ToMouseLocked = (ctx, pointV2, lockedAngleStep = 45 ) => {
    const lockPointPos = getLockPointPos(pointV2, lockedAngleStep);

    ctx.beginPath();
    let posX = pointV2.modelCorePoint.mixins.movable.posX;
    let posY = pointV2.modelCorePoint.mixins.movable.posY;
    let pointField = getPointField(posX, posY);
    ctx.moveTo(pointField.x, pointField.y);

    ctx.lineTo(lockPointPos.x, lockPointPos.y);
    ctx.stroke();
    ctx.closePath();
  }

  // static renderCursor = (ctx) => {
  //   if (RenderFreeDraw.cursorImage && this.cursorImage.image && (this.arcLength > 0 || this.angle > 0) && ($(window).width() > 768)) {
  //     let mPos = EventManager.LastKnownMousePos;
  //     if (mPos) {
  //       ctx.drawImage(this.cursorImage.image, mPos.x + 10, mPos.y + 10, this.cursorImage.width, this.cursorImage.height);
  //     }
  //   }
  // };

  static renderLinesBetweenPoints = (ctx, state) => {
    ctx.beginPath();
    RenderFreeDraw.drawLines(ctx, state.addedPoints);
    ctx.stroke();
    // if (state.isDrawFinished) {
    //   RenderFreeDraw.drawLastLine(ctx, state);
    // } else
    if (state.drawLineToMouse && state.addedPoints.length !== 0 ) {
      RenderFreeDraw.drawLineFromPointV2ToMouse(ctx, state.addedPoints[state.addedPoints.length -1], state.useLockedPoints)
    }
  };

  static render = (ctx, state) => {
    RenderFreeDraw.renderLines(ctx, state);
    //RenderFreeDraw.updateDimensionToMouse(ctx, state);
  };

  static renderLines = (ctx, state) => {
    //RenderFreeDraw.renderCursor(ctx);
    if (state.drawType === FREE_DRAW_TYPE.wall) {
      ctx.lineWidth = state.lineWidth + 2;
      ctx.strokeStyle = state.outlineColor;
      RenderFreeDraw.renderLinesBetweenPoints(ctx, state);
    }
    ctx.lineWidth = state.lineWidth;
    ctx.strokeStyle = state.lineColor;
    RenderFreeDraw.renderLinesBetweenPoints(ctx, state);
  };

  // static renderDimensionToMouse = (ctx, state) => {
  //   if (state.dimensionToMouse.value > state.minLineLength) {
  //     state.dimensionToMouse.pos.betweenPoints.pointFrom = state.addedPoints[state.addedPoints.length - 1]
  //     state.dimensionToMouse.pos.betweenPoints.pointTo = getMousePositionOnField(
  //       EventManager.LastKnownMousePos.x,
  //       EventManager.LastKnownMousePos.y
  //     );
  //     //state.dimensionToMouse.render(ctx);
  //   }
  // };
}
